import * as React from "react"

function IconBullet(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.75 6C2.75 5.17 3.42 4.5 4.25 4.5C5.08 4.5 5.75 5.17 5.75 6C5.75 6.83 5.08 7.5 4.25 7.5C3.42 7.5 2.75 6.83 2.75 6ZM2.75 12C2.75 11.17 3.42 10.5 4.25 10.5C5.08 10.5 5.75 11.17 5.75 12C5.75 12.83 5.08 13.5 4.25 13.5C3.42 13.5 2.75 12.83 2.75 12ZM4.25 16.5C3.42 16.5 2.75 17.18 2.75 18C2.75 18.82 3.43 19.5 4.25 19.5C5.07 19.5 5.75 18.82 5.75 18C5.75 17.18 5.08 16.5 4.25 16.5ZM20.25 19H8.25C7.7 19 7.25 18.55 7.25 18C7.25 17.45 7.7 17 8.25 17H20.25C20.8 17 21.25 17.45 21.25 18C21.25 18.55 20.8 19 20.25 19ZM8.25 13H20.25C20.8 13 21.25 12.55 21.25 12C21.25 11.45 20.8 11 20.25 11H8.25C7.7 11 7.25 11.45 7.25 12C7.25 12.55 7.7 13 8.25 13ZM8.25 7C7.7 7 7.25 6.55 7.25 6C7.25 5.45 7.7 5 8.25 5H20.25C20.8 5 21.25 5.45 21.25 6C21.25 6.55 20.8 7 20.25 7H8.25Z" fill="white"/>
    </svg>

  )
}

export default IconBullet
